import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=1bf609cf&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=ts&"
export * from "./Comment.vue?vue&type=script&lang=ts&"
import style0 from "./Comment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=1bf609cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf609cf",
  null
  
)

export default component.exports